import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { isEmpty } from "lodash";
import { Link, useParams, withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  Label,
  Nav,
  NavItem,
  NavLink,
  Pagination,
  PaginationItem,
  PaginationLink,
  Progress,
  Row,
  TabContent,
  Badge,
  Table,
  TabPane,
  UncontrolledCollapse,
  UncontrolledDropdown,
  FormFeedback,
  Button,
  ModalBody,
  Form,
  ModalHeader,
  Modal,
  ModalFooter,
} from "reactstrap";
import classnames from "classnames";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay } from "swiper";

// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
//Images
import profileBg from "../../../assets/images/profile-bg.jpg";
import avatar1 from "../../../assets/images/users/avatar-1.jpg";
import avatar2 from "../../../assets/images/users/avatar-2.jpg";
import avatar3 from "../../../assets/images/users/avatar-3.jpg";
import avatar4 from "../../../assets/images/users/avatar-4.jpg";
import avatar5 from "../../../assets/images/users/avatar-5.jpg";
import avatar6 from "../../../assets/images/users/avatar-6.jpg";
import avatar7 from "../../../assets/images/users/avatar-7.jpg";
import avatar8 from "../../../assets/images/users/avatar-8.jpg";
import dummyImg from "../../../assets/images/users/user-dummy-img.jpg";

import smallImage2 from "../../../assets/images/small/img-2.jpg";
import smallImage3 from "../../../assets/images/small/img-3.jpg";
import smallImage4 from "../../../assets/images/small/img-4.jpg";
import smallImage5 from "../../../assets/images/small/img-5.jpg";
import smallImage6 from "../../../assets/images/small/img-6.jpg";
import smallImage7 from "../../../assets/images/small/img-7.jpg";
import smallImage9 from "../../../assets/images/small/img-9.jpg";

import axiosInstance from "../../../axiosConfig";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../../Components/Common/Loader";
import BreadCrumb from "../../../Components/Common/BreadCrumb";

const LivreursDetail = (props) => {
  const dispatch = useDispatch();
  const [selectDriver, setSelectDriver] = useState({});

  const { livreurs, isLivreurCreated, isLivreurSuccess, error } = useSelector(
    (state) => ({
      livreurs: state.Livreur.livreurs,
      isLivreurCreated: state.Livreur.isLivreurCreated,
      isLivreurSuccess: state.Livreur.isLivreurSuccess,
      error: state.Livreur.error,
    })
  );

  // Fonction pour calculer le revenu total
  const calculerRevenuTotal = (data) => {
    return data.reduce((total, item) => {
      return total + item.revenu_mensuel;
    }, 0);
  };

  //Début code pour get le livreur sélectionné
  const livreurId = useParams("id");
  // console.log("numcon", livreurId.id);
  const url = process.env.REACT_APP_API_URL;
  const token = JSON.parse(localStorage.getItem("authUser"))
    ? JSON.parse(localStorage.getItem("authUser")).access
    : null;
  // if ( token )
  //   axios.defaults.headers.common[ "Authorization" ] = "Bearer " + token;

  const [selectLivreur, setSelectLivreur] = useState({});
  const [livreurCourses, setLivreurCourses] = useState({});
  const [modal, setModal] = useState(false);
  const [isEditPhone, setIsEditPhone] = useState(false);

  const fetchDataDetail = async () => {
    try {
      // « /ldetail/ » n'existe pas côté serveur : chauffeurs et livreurs
      // partagent la même table, et « /driverdetail/ » les sert tous les deux.
      const driverdetail = await axiosInstance.get(`/driverdetail/`, {
        params: { id: livreurId.id },
      });
      setSelectLivreur(driverdetail.data.data);
      // console.log(driverdetail);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchDataDetail();
  }, [livreurId, url]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const revenusDetail = await axiosInstance.get(
          `/revenuconducteur/?id=${livreurId.id}/`
        );
        setLivreurCourses(revenusDetail.data.data);
        // console.log(revenusDetail);
      } catch (err) {
        console.error("Echec de récupération des courses du livreur ", err);
      }
    };
    fetchData();
  }, [livreurId, url]);

  useEffect(() => {
    // console.log("selectLivreur", selectLivreur);
    // console.log("selectLivreur.length", Object.keys(selectLivreur).length);
    if (!isEmpty(selectLivreur)) setSelectLivreur(selectLivreur);
  }, [selectLivreur]);

  SwiperCore.use([Autoplay]);

  const [activeTab, setActiveTab] = useState("1");
  const [activityTab, setActivityTab] = useState("1");

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  const toggleActivityTab = (tab) => {
    if (activityTab !== tab) {
      setActivityTab(tab);
    }
  };

   function formatDate(date) {
     const dateObject = new Date(date).toLocaleDateString("fr-FR", {
       year: "numeric",
       month: "long",
       day: "numeric",
       hour: "2-digit",
       minute: "2-digit",
       second: "2-digit",
       timeZoneName: "short",
     });
     return dateObject;
   }

  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      first_name: (selectLivreur && selectLivreur.first_name) || "",
      last_name: (selectLivreur && selectLivreur.last_name) || "",
      email: (selectLivreur && selectLivreur.email) || "",
      telephone: (selectLivreur && selectLivreur.telephone) || "",
      type_conducteur:
        (selectLivreur && selectLivreur.type_conducteur) || "Conducteur",
      cg: (selectLivreur && selectLivreur.cg) || "",
      code_parrain: (selectLivreur && selectLivreur.code_parrain) || "",
      password: (selectLivreur && selectLivreur.password) || "",
    },
    validationSchema: Yup.object({
      first_name:
        !isEditPhone &&
        Yup.string().required(props.t("Veuillez renseigner les prénoms")),
      last_name:
        !isEditPhone &&
        Yup.string().required(props.t("Veuillez renseigner le nom")),
      email:
        !isEditPhone &&
        Yup.string().required(props.t("Veuillez renseigner l'email")),
      telephone: Yup.string().required(
        props.t("Veuillez renseigner le numero de téléphone")
      ),
      type_conducteur:
        !isEditPhone &&
        Yup.string().required(
          props.t("Veuillez renseigner le type de conducteur")
        ),
      cg:
        !isEditPhone &&
        Yup.string().required(props.t("Veuillez renseigner la carte grise")),
      password:
        !isEditPhone &&
        Yup.string().required(props.t("Veuillez renseigner le mot de passe")),
    }),
    onSubmit: async (values) => {
      // console.log("isEditPhone: ", isEditPhone);

      if (!isEditPhone) {
        const updateLivreur = {
          first_name: values.first_name,
          last_name: values.last_name,
          email: values.email,
        };

        // console.log("updateLivreur:", updateLivreur);
        // console.log("selectLivreur.user_id:", selectLivreur.user_id);

        try {
          const data = axiosInstance
            .put(
              `/driverinfoupdate/?id=${selectLivreur.user_id}/`,
              updateLivreur
            )
            .then((response) => {
              validation.resetForm();
              toast.success(props.t("Livreur modifié avec succès"), {
                autoClose: 3000,
              });
            })
            .catch((error) => {
              toast.error(props.t("Echec de la modification du Livreur"), {
                autoClose: 3000,
              });
            });

          // window.location.reload(true);
        } catch (err) {
          console.error(err);
          toast.error(props.t("Echec de la modification du Livreur"), {
            autoClose: 2000,
          });
        }
      } else {
        const updatePhoneLivreur = {
          newTelephone: values.telephone,
        };

        // console.log("updatePhoneLivreur:", updatePhoneLivreur);
        try {
          const data = axiosInstance
            .put(
              `/driverchangephone/?id=${selectLivreur.user_id}/`,
              updatePhoneLivreur
            )
            .then((response) => {
              validation.resetForm();
              toast.success(
                props.t("Numero de téléphone du livreur modifié avec succès"),
                { autoClose: 3000 }
              );
            });
        } catch (error) {
          console.error(
            "Echec de la modification du numero de téléphone du Livreur ",
            error
          );
          toast.error(
            props.t(
              "Echec de la modification du numero de téléphone du Livreur"
            ),
            { autoClose: 3000 }
          );
        }
      }

      await fetchDataDetail();
      setModal(false);
    },
  });

  document.title = "Détails Livreur | Takci";

  return (
    <React.Fragment>
      <div className="page-content">
        <BreadCrumb
          title={props.t("Détails livreur")}
          pageTitle="Livreurs"
          pageTitleLink="/livreur"
        />

        <Container fluid>
          {selectLivreur && Object.keys(selectLivreur).length !== 0 ? (
            <>
              <div className="profile-foreground position-relative mx-n4 mt-n4">
                <div className="profile-wid-bg">
                  <img src={profileBg} alt="" className="profile-wid-img" />
                </div>
              </div>
              <div className="pt-4 mb-4 mb-lg-3 pb-lg-4 profile-wrapper">
                <Row className="g-4">
                  <div className="col-auto">
                    <div className="avatar-lg">
                      <img
                        src={dummyImg}
                        alt="user-img"
                        className="img-thumbnail rounded-circle"
                      />
                    </div>
                  </div>

                  <Col>
                    <div className="p-2">
                      <h3 className="text-white mb-1">
                        {selectLivreur.last_name || (
                          <Badge color="danger">Non renseignée</Badge>
                        )}{" "}
                        {selectLivreur.first_name || (
                          <Badge color="danger">Non renseignée</Badge>
                        )}
                      </h3>
                      <p className="text-white-75">Livreur</p>
                      <div className="hstack text-white-50 gap-1">
                        <div className="me-2">
                          <i className="ri-map-pin-user-line me-1 text-white-75 fs-16 align-middle"></i>
                          {selectLivreur.ville || (
                            <Badge color="danger">Non renseignée</Badge>
                          )}
                        </div>
                      </div>
                    </div>
                  </Col>

                  <Col xs={12} className="col-lg-auto order-last order-lg-0">
                    <Row className="text text-white-50 text-center">
                      <Col lg={6} xs={4}>
                        <div className="p-2">
                          <h4 className="text-white mb-1">
                            {Object.keys(livreurCourses).length}
                          </h4>
                          <p className="fs-14 mb-0">Courses</p>
                        </div>
                      </Col>
                      <Col lg={6} xs={4}>
                        <div className="p-2">
                          <h4 className="text-white mb-1">
                            {Object.keys(livreurCourses).length > 0 &&
                              calculerRevenuTotal(livreurCourses)}
                          </h4>
                          <p className="fs-14 mb-0">Gains</p>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>
            </>
          ) : (
            <>
              <div className="text-center my-3">
                <Loader style={{ color: "#014c94" }} />
                        <h2>Chargement...</h2>
              </div>
            </>
          )}

          <Row>
            <Col lg={12}>
              <div>
                <div className="d-flex profile-wrapper">
                  <Nav
                    pills
                    className="animation-nav profile-nav gap-2 gap-lg-3 flex-grow-1"
                    role="tablist"
                  >
                    <NavItem>
                      <NavLink
                        href="#"
                        className={classnames({ active: activeTab === "1" })}
                        onClick={() => {
                          toggleTab("1");
                        }}
                      >
                        <i className="ri-airplay-fill d-inline-block d-md-none"></i>{" "}
                        <span className="d-none d-md-inline-block">
                          Infos Personnelles
                        </span>
                      </NavLink>
                    </NavItem>

                    <NavItem>
                      <NavLink
                        href="#"
                        className={classnames({ active: activeTab === "2" })}
                        onClick={() => {
                          toggleTab("2");
                        }}
                      >
                        <i className="ri-folder-4-line d-inline-block d-md-none"></i>{" "}
                        <span className="d-none d-md-inline-block">
                          Documents
                        </span>
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <div className="flex-shrink-0">
                    <Link
                      to="#"
                      style={{ background: "#002437", color: "white" }}
                      className="btn"
                      onClick={() => {
                        setModal(true);
                      }}
                    >
                      <i className="ri-edit-box-line align-bottom"></i>
                      {props.t("Edit")}
                    </Link>
                  </div>
                </div>

                <TabContent activeTab={activeTab} className="pt-4">
                  <TabPane tabId="1">
                    <Row>
                      <Col xxl={12}>
                        <Card>
                          <CardBody>
                            <h5 className="card-title mb-3">Infos</h5>

                            {selectLivreur &&
                            Object.keys(selectLivreur).length !== 0 ? (
                              <>
                                <div className="table-responsive">
                                  <Table className="table-borderless mb-0">
                                    <tbody>
                                      <tr>
                                        <th className="ps-0" scope="row">
                                          {props.t("Full Name")}:
                                        </th>
                                        <td className="text-muted">
                                          {selectLivreur.last_name || (
                                            <Badge color="danger">
                                              Non renseignée
                                            </Badge>
                                          )}{" "}
                                          {selectLivreur.first_name || (
                                            <Badge color="danger">
                                              Non renseignée
                                            </Badge>
                                          )}
                                        </td>
                                      </tr>
                                      <tr>
                                        <th className="ps-0" scope="row">
                                          {props.t("Phone number")}:
                                        </th>
                                        <td className="text-muted">
                                          {(selectLivreur.telephone && (
                                            <>
                                              <a
                                                href={`tel: ${selectLivreur.telephone}`}
                                              >
                                                {selectLivreur.telephone}
                                              </a>
                                              <Link
                                                to="#"
                                                className="text-warning d-inline-block"
                                                onClick={() => {
                                                  setIsEditPhone(true);
                                                  setModal(true);
                                                }}
                                              >
                                                <i className="ri-pencil-fill align-top"></i>
                                              </Link>
                                            </>
                                          )) || (
                                            <Badge color="danger">
                                              Non renseignée
                                            </Badge>
                                          )}
                                        </td>
                                      </tr>
                                      <tr>
                                        <th className="ps-0" scope="row">
                                          {props.t("Email")}:
                                        </th>
                                        <td className="text-muted">
                                          {(selectLivreur.email && (
                                            <a
                                              href={`mailto: ${selectLivreur.email}`}
                                            >
                                              {selectLivreur.email}
                                            </a>
                                          )) || (
                                            <Badge color="danger">
                                              Non renseignée
                                            </Badge>
                                          )}
                                        </td>
                                      </tr>
                                      <tr>
                                        <th className="ps-0" scope="row">
                                          {props.t("Joining Date")}
                                        </th>
                                        <td className="text-muted">
                                          {(selectLivreur.created_at &&
                                            formatDate(
                                              selectLivreur.created_at
                                            )) || (
                                            <Badge color="danger">
                                              Non renseignée
                                            </Badge>
                                          )}
                                        </td>
                                      </tr>
                                    </tbody>
                                  </Table>
                                </div>
                              </>
                            ) : (
                              <>
                                <div className="text-center my-3">
                                  <Loader style={{ color: "#014c94" }} />
                        <h2>Chargement...</h2>
                                </div>
                              </>
                            )}
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                  </TabPane>

                  <TabPane tabId="2">
                    <Card>
                      <CardBody>
                        <div className="d-flex align-items-center mb-4">
                          <h5 className="card-title flex-grow-1 mb-0">
                            Documents
                          </h5>
                        </div>
                        <Row>
                          <Col lg={12}>
                            <div className="table-responsive">
                              {selectLivreur &&
                              Object.keys(selectLivreur).length !== 0 ? (
                                <>
                                  <Table className="table-borderless align-middle mb-0">
                                    <thead className="table-light">
                                      <tr>
                                        <th scope="col">Fichiers</th>
                                        {/* <th scope="col">Type</th>
                                    <th scope="col">Taille</th>
                                    <th scope="col">Upload Date</th> */}
                                        <th scope="col">Action</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <td>
                                          <div className="d-flex align-items-center">
                                            <div className="avatar-sm">
                                              <div
                                                className={`avatar-title bg-soft-${
                                                  selectLivreur.attestation_residence
                                                    ? "primary"
                                                    : "danger"
                                                } text-${
                                                  selectLivreur.attestation_residence
                                                    ? "primary"
                                                    : "danger"
                                                } rounded fs-20`}
                                              >
                                                <i className="ri-image-2-fill"></i>
                                              </div>
                                            </div>
                                            <div className="ms-3 flex-grow-1">
                                              <h6 className="fs-15 mb-0">
                                                <Link to="#">
                                                  {selectLivreur.attestation_residence
                                                    ? selectLivreur.attestation_residence
                                                    : "Pas d'attestation de résidence"}
                                                </Link>
                                              </h6>
                                            </div>
                                          </div>
                                        </td>
                                        <td>
                                          <UncontrolledDropdown
                                            direction="start"
                                            disabled={
                                              !selectLivreur.attestation_residence
                                            }
                                          >
                                            <DropdownToggle
                                              tag="a"
                                              className="btn btn-light btn-icon"
                                              id="dropdownMenuLink15"
                                              role="button"
                                            >
                                              <i className="ri-equalizer-fill"></i>
                                            </DropdownToggle>
                                            <DropdownMenu>
                                              <DropdownItem>
                                                <i className="ri-pencil-fill me-2 align-middle text-muted" />
                                                Modifier
                                              </DropdownItem>
                                              <DropdownItem>
                                                <i className="ri-eye-fill me-2 align-middle text-muted" />
                                                Visualiser
                                              </DropdownItem>
                                              <DropdownItem>
                                                <i className="ri-download-2-fill me-2 align-middle text-muted" />
                                                Télécharger
                                              </DropdownItem>
                                            </DropdownMenu>
                                          </UncontrolledDropdown>
                                        </td>
                                      </tr>

                                      {/* Permis */}
                                      <tr>
                                        <td>
                                          <div className="d-flex align-items-center">
                                            <div className="avatar-sm">
                                              <div
                                                className={`avatar-title bg-soft-${
                                                  selectLivreur.permis
                                                    ? "primary"
                                                    : "danger"
                                                } text-${
                                                  selectLivreur.permis
                                                    ? "primary"
                                                    : "danger"
                                                } rounded fs-20`}
                                              >
                                                <i className="ri-image-2-fill"></i>
                                              </div>
                                            </div>
                                            <div className="ms-3 flex-grow-1">
                                              <h6 className="fs-15 mb-0">
                                                <Link to="#">
                                                  {selectLivreur.permis
                                                    ? selectLivreur.permis
                                                    : "Pas de permis"}
                                                </Link>
                                              </h6>
                                            </div>
                                          </div>
                                        </td>
                                        <td>
                                          <UncontrolledDropdown
                                            direction="start"
                                            disabled={!selectLivreur.permis}
                                          >
                                            <DropdownToggle
                                              tag="a"
                                              className="btn btn-light btn-icon"
                                              id="dropdownMenuLink15"
                                              role="button"
                                            >
                                              <i className="ri-equalizer-fill"></i>
                                            </DropdownToggle>
                                            <DropdownMenu>
                                              <DropdownItem>
                                                <i className="ri-pencil-fill me-2 align-middle text-muted" />
                                                Modifier
                                              </DropdownItem>
                                              <DropdownItem>
                                                <i className="ri-eye-fill me-2 align-middle text-muted" />
                                                Visualiser
                                              </DropdownItem>
                                              <DropdownItem>
                                                <i className="ri-download-2-fill me-2 align-middle text-muted" />
                                                Télécharger
                                              </DropdownItem>
                                            </DropdownMenu>
                                          </UncontrolledDropdown>
                                        </td>
                                      </tr>

                                      {/* Photo */}
                                      <tr>
                                        <td>
                                          <div className="d-flex align-items-center">
                                            <div className="avatar-sm">
                                              <div
                                                className={`avatar-title bg-soft-${
                                                  selectLivreur.photo
                                                    ? "primary"
                                                    : "danger"
                                                } text-${
                                                  selectLivreur.photo
                                                    ? "primary"
                                                    : "danger"
                                                } rounded fs-20`}
                                              >
                                                <i className="ri-image-2-fill"></i>
                                              </div>
                                            </div>
                                            <div className="ms-3 flex-grow-1">
                                              <h6 className="fs-15 mb-0">
                                                <Link to="#">
                                                  {selectLivreur.photo
                                                    ? selectLivreur.photo
                                                    : "Pas de photo"}
                                                </Link>
                                              </h6>
                                            </div>
                                          </div>
                                        </td>
                                        <td>
                                          <UncontrolledDropdown
                                            direction="start"
                                            disabled={!selectLivreur.photo}
                                          >
                                            <DropdownToggle
                                              tag="a"
                                              className="btn btn-light btn-icon"
                                              id="dropdownMenuLink15"
                                              role="button"
                                            >
                                              <i className="ri-equalizer-fill"></i>
                                            </DropdownToggle>
                                            <DropdownMenu>
                                              <DropdownItem>
                                                <i className="ri-pencil-fill me-2 align-middle text-muted" />
                                                Modifier
                                              </DropdownItem>
                                              <DropdownItem>
                                                <i className="ri-eye-fill me-2 align-middle text-muted" />
                                                Visualiser
                                              </DropdownItem>
                                              <DropdownItem>
                                                <i className="ri-download-2-fill me-2 align-middle text-muted" />
                                                Télécharger
                                              </DropdownItem>
                                            </DropdownMenu>
                                          </UncontrolledDropdown>
                                        </td>
                                      </tr>

                                      {/* Piece d'identite */}
                                      <tr>
                                        <td>
                                          <div className="d-flex align-items-center">
                                            <div className="avatar-sm">
                                              <div
                                                className={`avatar-title bg-soft-${
                                                  selectLivreur.piece_identite
                                                    ? "primary"
                                                    : "danger"
                                                } text-${
                                                  selectLivreur.piece_identite
                                                    ? "primary"
                                                    : "danger"
                                                } rounded fs-20`}
                                              >
                                                <i className="ri-image-2-fill"></i>
                                              </div>
                                            </div>
                                            <div className="ms-3 flex-grow-1">
                                              <h6 className="fs-15 mb-0">
                                                <Link to="#">
                                                  {selectLivreur.piece_identite
                                                    ? selectLivreur.piece_identite
                                                    : "Pas de piece d'identite"}
                                                </Link>
                                              </h6>
                                            </div>
                                          </div>
                                        </td>
                                        <td>
                                          <UncontrolledDropdown
                                            direction="start"
                                            disabled={
                                              !selectLivreur.piece_identite
                                            }
                                          >
                                            <DropdownToggle
                                              tag="a"
                                              className="btn btn-light btn-icon"
                                              id="dropdownMenuLink15"
                                              role="button"
                                            >
                                              <i className="ri-equalizer-fill"></i>
                                            </DropdownToggle>
                                            <DropdownMenu>
                                              <DropdownItem>
                                                <i className="ri-pencil-fill me-2 align-middle text-muted" />
                                                Modifier
                                              </DropdownItem>
                                              <DropdownItem>
                                                <i className="ri-eye-fill me-2 align-middle text-muted" />
                                                Visualiser
                                              </DropdownItem>
                                              <DropdownItem>
                                                <i className="ri-download-2-fill me-2 align-middle text-muted" />
                                                Télécharger
                                              </DropdownItem>
                                            </DropdownMenu>
                                          </UncontrolledDropdown>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </Table>
                                </>
                              ) : (
                                <>
                                  <div className="text-center my-3">
                                    <Loader style={{ color: "#014c94" }} />
                        <h2>Chargement...</h2>
                                  </div>
                                </>
                              )}
                            </div>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                  </TabPane>
                </TabContent>
              </div>
            </Col>
          </Row>

          <Modal
            id="showModal"
            style={{ maxWidth: 800 }}
            isOpen={modal}
            centered
          >
            <ModalHeader className="bg-soft-info p-3">
              {isEditPhone
                ? props.t("Modifier le numero")
                : props.t("Modifier Livreur")}
            </ModalHeader>

            <Form
              onSubmit={async (e) => {
                e.preventDefault();
                validation.handleSubmit();

                setModal(false);
                await fetchDataDetail();
              }}
            >
              <ModalBody>
                <Input type="hidden" id="id-field" />
                <Row className="g-3">
                  {!isEditPhone && (
                    <>
                      <Col lg={4}>
                        <div>
                          <Label htmlFor="last_name" className="form-label">
                            {props.t("Last Name")}{" "}
                            <span style={{ color: "red" }}>*</span>
                          </Label>
                          <Input
                            name="last_name"
                            id="last_name"
                            className="form-control"
                            placeholder={props.t("Entrez le nom")}
                            type="text"
                            validate={{
                              required: { value: true },
                            }}
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.last_name || ""}
                            invalid={
                              validation.touched.last_name &&
                              validation.errors.last_name
                                ? true
                                : false
                            }
                          />
                          {validation.touched.last_name &&
                          validation.errors.last_name ? (
                            <FormFeedback type="invalid">
                              {validation.errors.last_name}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                      <Col lg={4}>
                        <div>
                          <Label htmlFor="first_name" className="form-label">
                            {props.t("First Name")}{" "}
                            <span style={{ color: "red" }}>*</span>
                          </Label>
                          <Input
                            name="first_name"
                            id="first_name"
                            className="form-control"
                            placeholder={props.t("Entrez les prénoms")}
                            type="text"
                            validate={{
                              required: { value: true },
                            }}
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.first_name || ""}
                            invalid={
                              validation.touched.first_name &&
                              validation.errors.first_name
                                ? true
                                : false
                            }
                          />
                          {validation.touched.first_name &&
                          validation.errors.first_name ? (
                            <FormFeedback type="invalid">
                              {validation.errors.first_name}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                      <Col lg={4}>
                        <div>
                          <Label htmlFor="email" className="form-label">
                            {props.t("Email")}{" "}
                            <span style={{ color: "red" }}>*</span>
                          </Label>
                          <Input
                            name="email"
                            id="email"
                            className="form-control"
                            placeholder={props.t("Entrez l'email")}
                            type="email"
                            validate={{
                              required: { value: true },
                            }}
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.email || ""}
                            invalid={
                              validation.touched.email &&
                              validation.errors.email
                                ? true
                                : false
                            }
                          />
                          {validation.touched.email &&
                          validation.errors.email ? (
                            <FormFeedback type="invalid">
                              {validation.errors.email}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                    </>
                  )}

                  <Col lg={4}>
                    <div>
                      <Label htmlFor="telephone" className="form-label">
                        {props.t("Numéro de téléphone")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </Label>
                      <Input
                        name="telephone"
                        id="telephone"
                        className="form-control"
                        placeholder={props.t("Entrez le numéro de téléphone")}
                        type="text"
                        validate={{
                          required: { value: true },
                        }}
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.telephone || ""}
                        invalid={
                          validation.touched.telephone &&
                          validation.errors.telephone
                            ? true
                            : false
                        }
                      />
                      {validation.touched.telephone &&
                      validation.errors.telephone ? (
                        <FormFeedback type="invalid">
                          {validation.errors.telephone}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>

                  {!isEditPhone && (
                    <>
                      <Col lg={4}>
                        <div>
                          <Label
                            htmlFor="type_conducteur"
                            className="form-label"
                          >
                            {props.t("Type conducteur")}{" "}
                            <span style={{ color: "red" }}>*</span>
                          </Label>
                          <Input
                            name="type_conducteur"
                            id="type_conducteur"
                            className="form-control"
                            readOnly
                            placeholder={props.t("Entrez le type conducteur")}
                            type="text"
                            validate={{
                              required: { value: true },
                            }}
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={
                              validation.values.type_conducteur || "Conducteur"
                            }
                            invalid={
                              validation.touched.type_conducteur &&
                              validation.errors.type_conducteur
                                ? true
                                : false
                            }
                          />
                          {validation.touched.type_conducteur &&
                          validation.errors.type_conducteur ? (
                            <FormFeedback type="invalid">
                              {validation.errors.type_conducteur}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                      <Col lg={4}>
                        <div>
                          <Label htmlFor="code_parrain" className="form-label">
                            {props.t("Code de parainnage")}
                          </Label>
                          <Input
                            name="code_parrain"
                            id="code_parrain"
                            className="form-control"
                            placeholder={props.t(
                              "Entrez le code de parainnage"
                            )}
                            type="text"
                            validate={{
                              required: { value: true },
                            }}
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.code_parrain || ""}
                            invalid={
                              validation.touched.code_parrain &&
                              validation.errors.code_parrain
                                ? true
                                : false
                            }
                          />
                          {validation.touched.code_parrain &&
                          validation.errors.code_parrain ? (
                            <FormFeedback type="invalid">
                              {validation.errors.code_parrain}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                      <Col lg={4}>
                        <div>
                          <Label className="form-label" htmlFor="cg">
                            {props.t("Numero de la carte Grise")}{" "}
                            <span style={{ color: "red" }}>*</span>
                          </Label>
                          <Input
                            type="text"
                            className="form"
                            id="cg"
                            name="cg"
                            value={validation.values.cg || ""}
                            // value={validation.values.piece_identite || ""}
                            onBlur={validation.handleBlur}
                            onChange={validation.handleChange}
                            invalid={
                              validation.errors.cg && validation.touched.cg
                                ? true
                                : false
                            }
                          />
                          {validation.errors.cg && validation.touched.cg ? (
                            <FormFeedback type="invalid">
                              {props.t(validation.errors.cg)}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                      <Col lg={4}>
                        <div>
                          <Label htmlFor="password" className="form-label">
                            {props.t("Mot de passe")}{" "}
                            <span style={{ color: "red" }}>*</span>
                          </Label>
                          <Input
                            name="password"
                            id="password"
                            className="form-control"
                            placeholder={props.t("Entrez le mot de passe")}
                            type="text"
                            validate={{
                              required: { value: true },
                            }}
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.password || ""}
                            invalid={
                              validation.touched.password &&
                              validation.errors.password
                                ? true
                                : false
                            }
                          />
                          {validation.touched.password &&
                          validation.errors.password ? (
                            <FormFeedback type="invalid">
                              {validation.errors.password}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                    </>
                  )}
                </Row>
              </ModalBody>
              <ModalFooter>
                <div className="hstack gap-2 justify-content-end">
                  <Button
                    type="button"
                    onClick={async () => {
                      setModal(false);
                      await fetchDataDetail();
                    }}
                    className="btn-light"
                  >
                    {props.t("Fermer")}
                  </Button>

                  <Button
                    type="submit"
                    className="btn"
                    style={{ background: "#002437", color: "white" }}
                    id="update-btn"
                  >
                    {isEditPhone
                      ? props.t("Edit")
                      : props.t("Modifier Livreur")}
                  </Button>
                </div>
              </ModalFooter>
            </Form>
          </Modal>

          <ToastContainer closeButton={false} />
        </Container>
      </div>
    </React.Fragment>
  );
};

LivreursDetail.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};
export default withRouter(withTranslation()(LivreursDetail));
